import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const pains = ['Stunden verschwendet mit der Suche nach aktuellen SPS-Übungsaufgaben und Schaltplänen.', 'Lernende, die sich langweilen, weil die Beispiele nicht zur Schweizer Industrie passen.', 'Wochenenden geopfert für Prüfungen, Arbeitsblätter und Lektionsplanung.', 'Kein System. Nur lose Blätter, halbfertige Ladder-Diagramme und veraltete Handbücher.', 'Industrie 4.0 im Lehrplan — aber kein didaktisches Material, das diesen Anspruch erfüllt.'];
export function PainSection() {
  return <section className="py-8 px-4 bg-brand-pain-bg border-y border-red-200" data-id="element-120">
      <div className="max-w-xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-122">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-charcoal mb-3" data-id="element-123">
            Montag. 07:15 Uhr.
          </h2>

          <p className="text-[15px] sm:text-base text-gray-700 mb-5 leading-relaxed" data-id="element-124">
            Der Unterricht beginnt in 45 Minuten. Sie öffnen Ihren Laptop. Die
            SPS-Handbücher von Siemens sind auf Englisch und 300 Seiten lang.
            Die Schüler wollen echte Industriefälle aus der Schweiz sehen —
            keine abstrakten Beispiele aus deutschen Fachbüchern von 2015. Das
            Oszilloskop im Labor funktioniert, aber die Übungsaufgaben dazu
            fehlen. Und Ihre freie Zeit am Wochenende ist schon wieder weg.
          </p>

          <div className="space-y-3 mb-5" data-id="element-125">
            {pains.map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-126">
                <XCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-brand-red shrink-0 mt-0.5" data-id="element-127" />
                <p className="text-brand-red font-bold text-[14px] sm:text-base leading-snug" data-id="element-128">
                  {item}
                </p>
              </div>)}
          </div>

          <p className="text-xl sm:text-2xl font-black text-brand-charcoal text-center" data-id="element-129">
            Es gibt einen besseren Weg.
          </p>
        </motion.div>
      </div>
    </section>;
}